export default "__VITE_ASSET__ac26b1fa__"